<template lang="pug">
  .block
    //- div( v-if="recordUrl" )
    //-   audio( controls :src="recordUrl" )
    //-     p.audio-message Ваш браузер не поддерживает HTML5-аудио.
    //-       a( :href="recordUrl" ) ссылка на аудиозапись
    
    //- v-divider.white
    //- div( ref="audio" )
    //- v-btn.my-3( v-if="recording" ref="start" color="#757575" @click="stopRecord" ) Остановить запись
    //- v-btn.my-3( v-else ref="stop" color="#757575" @click="startRecord" ) Начать запись
    
    //- v-divider.white

    div.red--text(v-if="JUDGE && (JUDGE.hall===null || JUDGE.hall==='')") Отсутствует номер зала
    div.my-3(v-else)
      v-btn( color="#757575" @click="openChat" )
        v-icon( size="24" color="white" ) videocam
        span.ml-2 Перейти к видеоконференции
      br
      v-btn.mt-3( color="#757575" @click="copyLink" )
        v-icon( size="24" color="white" ) file_copy
        span.ml-2 Скопировать ссылку
    
    v-snackbar(v-model="codeSnack" color="success" :timeout="3000" vertical top) Ссылка на видеоконференцию успешно скопирована
      v-btn(light text @click="codeSnack = false") Закрыть
      
</template>

<script>
import { caseService } from "@/_services"
import { mapGetters } from 'vuex'

import { config } from '@/_helpers'
import Meeting from '@/common/Meeting'

// eslint-disable-next-line
function activateAudioRecorder (owner) {
  navigator.mediaDevices.getUserMedia({ audio: true}).then(stream => {
    const mediaRecorder = new MediaRecorder(stream)
    
    var audioChunks = []
    mediaRecorder.addEventListener("dataavailable", function (event) {
      audioChunks.push(event.data)
    })

    mediaRecorder.addEventListener("stop", function () {
      const audioBlob = new Blob(audioChunks, {
        type: 'audio/wav'
      })
      const audioUrl = URL.createObjectURL(audioBlob)
      var audio = document.createElement('audio')
      audio.src = audioUrl
      audio.controls = true
      audio.autoplay = true

      let fd = new FormData()
      fd.append('file', audioBlob, 'file')
      caseService.sendRecord(owner.currentSession.id, fd)
      
      owner.$refs.audio.appendChild(audio)
      audioChunks = []
    })

    owner.mediaRecorder = mediaRecorder
  })
}

export default {
  mixins: [Meeting],

  data () {
    return {
      mediaRecorder: null,
      audioChunks: [],
      recording: false,
      copyDialog: false,
      codeSnack: false
    }
  },

  mounted () {
    this.$store.dispatch('judge/GET_JUDGE')
    // activateAudioRecorder(this)
  },

  computed: {
    ...mapGetters('courtCase', ['currentSession']),
    ...mapGetters('judge', ['JUDGE_FULLNAME', 'JUDGE']),

    recordUrl () {
      let { id } = this.currentSession
      return id && `${config.apiUrl}file/session/${id}`
    },

    fullname () {
      return this.JUDGE_FULLNAME || 'Судья'
    }
  },

  methods: {
    startRecord () {
      this.mediaRecorder.start()
      this.recording = true
    },

    stopRecord () {
      this.mediaRecorder.stop()
      this.recording = false
    },

    openChat () {
      let userUid = localStorage.getItem('useruuid').toString()
      let fio = `${localStorage.getItem('fio').toString()} (Судья)` || 'Судья'
      this.$_meeting_setCookieForUser(userUid, fio, true, false)

      let url = this.$_meeting_makeUrlForRoom(this.JUDGE.hall)
      window.open(url, '_blank')
    },

    copyLink () {
      let link = `${this.$_meeting_settings.host}/${this.JUDGE.hall}`
      navigator.clipboard.writeText(link).then(() => { this.codeSnack=true })
    },
  }
}
</script>

<style lang="scss" scoped>
.block {
  background: #F0F0F0;
  padding: 11px 32px 11px 20px;
  border-radius: 5px;
}
.audio {
  display: flex;
  justify-content: space-between;
}
.audio-message {
  font-size: 16px;
  line-height: 32px;
  color: #959595;
}
</style>